import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex, Input, FormField, Box, Button, getPaletteColor, SrOnly, Label } from 'pcln-design-system'
import { Search } from 'pcln-icons'
import styled from 'styled-components'

const propTypes = {
  className: PropTypes.string,
  placeholderText: PropTypes.string,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  buttonText: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  freeTextInputId: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  theme: PropTypes.object,
  autobotIdForInput: PropTypes.string,
  autobotIdForButton: PropTypes.string,
  minimal: PropTypes.bool,
  activeSearch: PropTypes.bool,
  buttonIsGrayWithNoInput: PropTypes.bool,
  searchFilterFontSize: PropTypes.string,
  showChip: PropTypes.bool,
  showSearchIconButton: PropTypes.bool,
}

const defaultProps = {
  className: '',
  placeholderText: 'Hotel Name...',
  buttonText: 'Apply',
  disabled: false,
  minimal: false,
  showChip: false,
}

const SearchContainer = styled(Box)`
  ${({ showChip }) =>
    showChip &&
    `width: 100%;
    `}
`

const SearchIcon = styled(Search)`
  position: relative;
  top: 3px;
`

const inputButtonStyles = (props) => `
${
  props.buttonIsGrayWithNoInput && !props.activeSearch && !props.disabled
    ? `
color: ${getPaletteColor('text.light')(props)};
background-color: ${getPaletteColor('background.base')(props)};

cursor: default;
&:hover{
  background-color: ${getPaletteColor('background.base')(props)};
  color: ${getPaletteColor('text.light')(props)};
}
`
    : ``
}
`

const StateChangingButton = styled(Button)`
  ${inputButtonStyles}
`

const SearchIconButton = styled(Button)`
  ${inputButtonStyles};
  line-height: 0;
  font-size: 0;
`

class FreeTextInputStateless extends Component {
  constructor(props) {
    super(props)
    this._handleSubmit = this.handleSubmit.bind(this)
    this._handleChange = this.handleChange.bind(this)
    this._handleKeyUp = this.handleKeyUp.bind(this)
  }

  componentDidMount() {
    if (this.props.value === undefined || this.props.value === null) {
      this.props.handleChange({
        [this.props.name]: this.props.defaultValue || '',
      })
    }
  }

  handleSubmit() {
    this.props.handleSubmit({ [this.props.name]: this.props.value })
  }

  handleChange(e) {
    this.props.handleChange({ [this.props.name]: e.target.value })
  }

  handleKeyUp(e) {
    if (e.keyCode === 13) {
      this.props.handleSubmit({ [this.props.name]: this.props.value })
    }
  }

  render() {
    const {
      activeSearch,
      buttonIsGrayWithNoInput,
      autobotIdForButton,
      autobotIdForInput,
      buttonText,
      className,
      disabled,
      freeTextInputId,
      minimal,
      placeholderText,
      value,
      searchFilterFontSize,
      showSearchIconButton,
      showChip,
    } = this.props

    const searchContainerWidth = showSearchIconButton ? '100%' : null
    return (
      <Flex className={className} alignItems='center'>
        <SearchContainer mr={1} showChip={showChip} width={searchContainerWidth}>
          <FormField>
            <SrOnly>
              <Label htmlFor={freeTextInputId}>{placeholderText}</Label>
            </SrOnly>
            {!minimal && <Search color={disabled ? 'text.light' : 'primary'} size={24} />}
            <Input
              mr={1}
              type='text'
              aria-label={placeholderText}
              disabled={disabled}
              placeholder={placeholderText}
              value={value || ''}
              onChange={this._handleChange}
              onKeyUp={this._handleKeyUp}
              fontSize={searchFilterFontSize}
              id={freeTextInputId}
              data-autobot-element-id={autobotIdForInput}
            />
          </FormField>
        </SearchContainer>
        {showChip || showSearchIconButton ? (
          <SearchIconButton
            data-testid='SEARCH_ICON_BUTTON'
            p={'15px'}
            activeSearch={activeSearch}
            buttonIsGrayWithNoInput={buttonIsGrayWithNoInput}
            disabled={disabled}
            onClick={buttonIsGrayWithNoInput && !activeSearch ? null : this._handleSubmit}
          >
            <Search size={18} />
          </SearchIconButton>
        ) : (
          <StateChangingButton
            size='large'
            data-testid='SEARCH_BUTTON'
            disabled={disabled}
            activeSearch={activeSearch}
            buttonIsGrayWithNoInput={buttonIsGrayWithNoInput}
            onClick={buttonIsGrayWithNoInput && !activeSearch ? null : this._handleSubmit}
            data-autobot-element-id={autobotIdForButton}
          >
            {minimal ? <SearchIcon color='text.lightest' size={24} /> : buttonText}
          </StateChangingButton>
        )}
      </Flex>
    )
  }
}

FreeTextInputStateless.propTypes = propTypes
FreeTextInputStateless.defaultProps = defaultProps

export default FreeTextInputStateless
